export const calculateRoi = (strategyNftCollection) => {
  const collectionValues = {
    usd: 0,
    eth: 0,
    roi: 0,
    roiPercentage: 0,
    entryPrice: 0,
  };

  strategyNftCollection.tokens.items.forEach((nftAsset) => {
    collectionValues.usd += nftAsset.token.floorAskPriceUsd;
    collectionValues.eth += nftAsset.token.floorAskPrice;
    collectionValues.entryPrice += nftAsset.strategyAsset.entryPrice;
  });

  collectionValues.roi = collectionValues.usd - collectionValues.entryPrice;
  collectionValues.roiPercentage =
    ((collectionValues.usd - collectionValues.entryPrice) /
      collectionValues.entryPrice) *
    100;

  return collectionValues;
};
